export const ADD_CITIES = 'ADD_CITIES'
export const ADD_CITY = 'ADD_CITY'

